import { createSlice } from "@reduxjs/toolkit";
import { loadCronActivities } from "./thunks/loadCronActivities.thunk";
import type { Activity } from "Api/activity/types";

interface CronActivitiesState {
  loading: boolean;
  error?: string;
  data: {
    [projectId: string]: {
      [environmentId: string]: {
        [cronName: string]: Activity[];
      };
    };
  };
}

const initialState: CronActivitiesState = {
  loading: false,
  error: undefined,
  data: {}
};

const cronActivitiesSlice = createSlice({
  name: "cronActivities",
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(loadCronActivities.fulfilled, (state, action) => {
        state.loading = false;
        const { projectId, environmentId, cronName, activities } =
          action.payload;
        if (!state.data[projectId]) {
          state.data[projectId] = {};
        }
        if (!state.data[projectId][environmentId]) {
          state.data[projectId][environmentId] = {};
        }
        state.data[projectId][environmentId][cronName] = activities;
      })
      .addCase(loadCronActivities.pending, state => {
        state.loading = true;
        state.error = undefined;
      })
      .addCase(loadCronActivities.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  }
});

export default cronActivitiesSlice.reducer;
